import { createAsyncThunk } from '@reduxjs/toolkit';

import { setUpdateInvoice } from '../services/setUpdateInvoice';
import { setUpdateMultipleInvoices } from '../services/setUpdateMultipleInvoices';

export const patchUpdateMultipleInvoices = createAsyncThunk(
  'invoices/patchUpdateMultipleInvoices',
  async ({invoiceIds, updateData, projectId: explicitProjectId}, { getState, dispatch }) => {
    // Prefer an explicit projectId from the caller (the invoices' own project);
    // fall back to the store's selectedProjectId for existing callers.
    const projectId = explicitProjectId || getState().projects.selectedProjectId;

    const response = await setUpdateMultipleInvoices(invoiceIds, projectId, updateData);
    return response;
  }
);
